import { render, staticRenderFns } from "./InfoGoodsSwipe.vue?vue&type=template&id=159d9672&scoped=true"
import script from "./InfoGoodsSwipe.vue?vue&type=script&lang=js"
export * from "./InfoGoodsSwipe.vue?vue&type=script&lang=js"
import style0 from "./InfoGoodsSwipe.vue?vue&type=style&index=0&id=159d9672&prod&lang=scss"
import style1 from "./InfoGoodsSwipe.vue?vue&type=style&index=1&id=159d9672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159d9672",
  null
  
)

export default component.exports